import { FunctionComponent, memo } from "react";
import { EllipsisMenu } from "@edgetier/client-components";
import SpellingExemptionEditAction from "../spelling-exemption-edit-action";
import SpellingExemptionRemoveAction from "../spelling-exemption-remove-action";
import { IProps } from "./spelling-configuration-actions-menu.types";
import "./spelling-configuration-actions-menu.scss";

/**
 * A dropdown menu to edit or remove a spelling exemption
 * @param props.exemption    Spelling exemption
 */
const SpellingConfigurationActionsMenu: FunctionComponent<IProps> = ({ exemption }) => {
    return (
        <div className="user-actions-menu">
            <EllipsisMenu placement="bottom-end" overflowContainer>
                <SpellingExemptionEditAction exemption={exemption} />
                <SpellingExemptionRemoveAction exemption={exemption} />
            </EllipsisMenu>
        </div>
    );
};

export default memo(SpellingConfigurationActionsMenu);
